import { useEffect, useRef, DependencyList } from 'react';

export default function useEffectWithPreviousDeps(effect: (deps?: DependencyList) => void, deps: DependencyList) {
    const prevDependencies = useRef<DependencyList | undefined>(undefined);
    useEffect(() => {
        effect(prevDependencies.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    useEffect(() => {
        prevDependencies.current = deps;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}
